import React, { useEffect, useState, useRef } from 'react';
import { consumeRequestedContextPath } from '../../utils/requestedContext';

interface CallbackPageProps {
  onCallback: (code: string) => Promise<void>;
}

const CallbackPage: React.FC<CallbackPageProps> = ({ onCallback }) => {
  const [error, setError] = useState<string | null>(null);
  const handled = useRef(false);

  useEffect(() => {
    // Prevent double-invocation in React StrictMode
    if (handled.current) return;
    handled.current = true;

    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const errorParam = params.get('error');
    const errorDescription = params.get('error_description');

    if (errorParam) {
      setError(errorDescription || errorParam);
      return;
    }

    if (code) {
      onCallback(code)
        .then(() => {
          window.history.replaceState({}, document.title, consumeRequestedContextPath());
        })
        .catch((err) => {
          setError(err.message || 'Authentication failed');
        });
    } else {
      setError('No authorization code received');
    }
  }, [onCallback]);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: '#121212',
    }}>
      <div style={{
        width: '100%',
        maxWidth: '400px',
        padding: '2.5rem',
        background: '#1a1a1e',
        borderRadius: '12px',
        border: '1px solid #2e2e2e',
        textAlign: 'center',
      }}>
        {error ? (
          <>
            <div style={{
              padding: '0.75rem',
              background: 'rgba(239, 68, 68, 0.1)',
              border: '1px solid rgba(239, 68, 68, 0.3)',
              borderRadius: '8px',
              color: '#ef4444',
              fontSize: '0.875rem',
              marginBottom: '1.5rem',
            }}>
              {error}
            </div>
            <a
              href="/"
              style={{
                color: '#8b5cf6',
                fontSize: '0.875rem',
                textDecoration: 'none',
              }}
            >
              ← Back to login
            </a>
          </>
        ) : (
          <>
            <div style={{
              display: 'inline-block',
              width: '32px',
              height: '32px',
              border: '3px solid rgba(139, 92, 246, 0.3)',
              borderTopColor: '#8b5cf6',
              borderRadius: '50%',
              animation: 'spin 0.6s linear infinite',
              marginBottom: '1rem',
            }} />
            <p style={{
              color: '#9ca3af',
              fontSize: '0.875rem',
              margin: 0,
            }}>
              Completing sign-in…
            </p>
          </>
        )}
      </div>

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default CallbackPage;
